import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import type { RootState, AppDispatch } from 'slices'
import { selectBranch, clearBranch, setCanSeeGlobalView } from 'slices/branchSlice'

export function useBranch() {
 const dispatch = useDispatch<AppDispatch>()
 const branchState = useSelector((state: RootState) => state.branch)

 const isGlobalView = branchState.viewMode === 'global'
 const isBranchView = branchState.viewMode === 'branch'

 const setBranch = useCallback((id: string | null) => {
 dispatch(selectBranch(id))
 }, [dispatch])

 const setGlobalAllowed = useCallback((allowed: boolean) => {
 dispatch(setCanSeeGlobalView(allowed))
 }, [dispatch])

 const reset = useCallback(() => {
 dispatch(clearBranch())
 }, [dispatch])

 return useMemo(() => ({
 ...branchState,
 isGlobalView,
 isBranchView,
 setBranch,
 setGlobalAllowed,
 reset,
 }), [branchState, isGlobalView, isBranchView, setBranch, setGlobalAllowed, reset])
}
